import { IconButton } from "@mui/material";
import { useState } from "react";
import GlobalDrawer from "src/components/Drawer/GlobalDrawer.jsx/GlobalDrawer";
import { MoreIcon } from "src/components/icons/purposed/ExpandCollapseIcon";
import SiteAppBarNavigationIcons from "../components/SiteAppBarNavigationIcons";
import { useUserData } from "src/context/userContext";
import SiteAppBarSearch from "../siteAppBarSearch/SiteAppBarSearch";

export default function SiteAppBarLoggedInLayout() {
  const { auth } = useUserData();
  const [globalDrawerIsOpen, setGlobalDrawerIsOpen] = useState(false);

  const menuId = "primary-search-account-menu";
  const toggleGlobalDrawer = () => {
    setGlobalDrawerIsOpen(!globalDrawerIsOpen);
  };

  return (
    <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
      <GlobalDrawer open={globalDrawerIsOpen} onClose={toggleGlobalDrawer} />
      <SiteAppBarNavigationIcons size="medium" onlyWide />
      {auth.page.haku.read && <SiteAppBarSearch />}
      <IconButton
        size="large"
        edge="end"
        aria-label="Näytä lisää"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={toggleGlobalDrawer}
        color="inherit">
        <MoreIcon />
      </IconButton>
    </div>
  );
}
